const TOKEN_KEY = 'patrol-auth-token'
const STAFF_KEY = 'patrol-auth-staff-guid'
const USERNAME_KEY = 'patrol-auth-username'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function setSession({ token, staffGuid, username }) {
  if (token) localStorage.setItem(TOKEN_KEY, token)
  if (staffGuid) localStorage.setItem(STAFF_KEY, staffGuid)
  if (username) localStorage.setItem(USERNAME_KEY, username)
}

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(STAFF_KEY)
  localStorage.removeItem(USERNAME_KEY)
}

export function isLoggedIn() {
  return !!getToken()
}

export function getStoredStaffGuid() {
  return localStorage.getItem(STAFF_KEY) || ''
}

export function getStoredUsername() {
  return localStorage.getItem(USERNAME_KEY) || ''
}

export default {
  getToken, setSession, clearSession, isLoggedIn, getStoredStaffGuid, getStoredUsername
}
